import React from 'react';

const ChatHeader = () => {
  return (
    <div className="mb-4 sm:mb-6 text-center font-inter px-4 flex flex-col items-center gap-3">
      <div className="flex items-center gap-3">
        <span
          className="font-semibold text-[1.8rem] sm:text-[2.6rem] tracking-tight"
          style={{
            background: 'linear-gradient(135deg, #1e293b 0%, #374151 60%, var(--color-primary) 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}
        >
          Welcome to
        </span>
        <img src="/a3-logo.png" alt="A3" className="h-11 sm:h-14 object-contain drop-shadow-sm" />
      </div>
      <p className="text-sm sm:text-base text-gray-400 font-normal tracking-wide " style={{ lineHeight: 1.6 }}>
        Your intelligent AI assistant - ask anything or pick a use case below
      </p>
    </div>
  );
};

export default ChatHeader;